import { ReportJob } from "../report-job.model";

export class DisplayReportJob {
	reportJob: ReportJob;
	title: string;
	subtitle: string;
	filename: string;
	status: string;
	reportType: string;
}

export const REPORTTYPES =  {
	EINLASSLISTE: "Einlassliste",
	VORVERKAUFSLISTE: "Vorverkaufsliste",
	EINFACHEVERKAUFSUEBERSICHT: "Einfache Verkaufsübersicht",
	DETAILVERKAUFSUEBERSICHT: "Detaillierte Verkaufsübersicht",
	VERANSTALTERABRECHNUNG: "Veranstalterabrechnung",
	VORVERKAUFSSTELLENABRECHNUNG: "Vorverkaufsstellenabrechnung",
	FREMDUMSAETZE: "Fremdumsätze"
}

export const STATUSTYPES = {
	LOADING: "wird geladen",
	DONE: "bereit",
	FAILED: "fehlgeschlagen",
	INVALIDATED: "nicht mehr verfügbar"
}
/*
status > 400 --> FAILED
status = 202 --> LOADING --> nix machen
status = 201 --> DONE
status = 404 if done before --> INVALIDATED
*/



// WEBPACK FOOTER //
// ./src/app/models/ui/reporting.ui-model.ts